module.exports = "/images/check.svg?bbf68c5b7181b6aa18e4dd9f997d0494";